import { useContext } from 'solid-js';
import { ChevronRightIcon } from '../../components/icons-library/chevron-right';
import { AppContext } from '../../app-context-provider/app-context-provider';

type NavControlsProps = {
    isFirst: boolean;
    isLast: boolean;
    onPrev: () => void;
    onNext: () => void;
};

export const NavControls = (props: NavControlsProps) => {
    const { localize } = useContext(AppContext);

    return (
        <div class="flex justify-center gap-cvi-6 pt-cvi-6">
            <button
                type="button"
                class="icon-button-secondary-neutral icon-button-secondary-neutral-md"
                onClick={props.onPrev}
                disabled={props.isFirst}
                aria-label={localize('slider-previous', 'Previous')}
            >
                <ChevronRightIcon class="rotate-180" fill="currentColor" size="small" />
            </button>
            <button
                type="button"
                class="icon-button-secondary-neutral icon-button-secondary-neutral-md"
                onClick={props.onNext}
                disabled={props.isLast}
                aria-label={localize('slider-next', 'Next')}
            >
                <ChevronRightIcon fill="currentColor" size="small" />
            </button>
        </div>
    );
};
